module.exports = __webpack_public_path__ + "img/undo.837333d4.svg";